import React, { FC } from 'react';
import clsx from 'clsx';
import { Button, Grid } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import i18next from 'i18next';
import { useStyles } from './styles';
import { useResponsiveSize } from '../../config/hooks/useResponsiveSize';
import { DeviceSensitive, UIBreakPoint } from '../../pages/StreamingWEBRTC/config';
import useStreamingLogic from '../../pages/StreamingWEBRTC/parts/hooks/useStreamingLogic';
import DisconnectDialog from '../../pages/StreamingWEBRTC/parts/DisconnectDialog';
import Menu from './parts/Menu';
import { IS_SIGN_UP_ENABLED } from '../../environment/environment';
import LoginAndUserMenu from './parts/LoginAndUserMenu';
import HeaderMobile from './parts/HeaderMobile';
import LogoAndBlogLink from './parts/LogoAndBlogLink';
import InfluencerMenu from './parts/InfluencerMenu';
import InfluencerSubmenu from './parts/InfluencerSubmenu/InfluencerSubmenu';
import EventPurchasedSubmenu from './parts/EventPurchasedSubmenu';

interface Props {
    isCreator?: boolean;
    purchased?: boolean;
    streamingPage?: boolean;
}

const Header: FC<Props> = ({ isCreator, purchased, streamingPage }) => {
    const classes = useStyles();
    const isMobileUI = useResponsiveSize(UIBreakPoint, DeviceSensitive);
    const { openDisconnectModal, disconnectEvent, setOpenDisconnectModal, closeEvent } = useStreamingLogic();

    const renderEventPageMenus = () => (
        <>
            <Grid item container className={clsx(classes.toolbarGrid, classes.menuItemsContainer)}>
                {isCreator ? <InfluencerMenu /> : <Menu />}
            </Grid>

            {IS_SIGN_UP_ENABLED && (
                <Grid item container className={classes.toolbarGrid}>
                    <LoginAndUserMenu />
                </Grid>
            )}
        </>
    );

    const renderDesktopToolbar = () => (
        <Toolbar className={classes.toolbar}>
            <Grid container xs={12} direction="row" justify="space-between">
                <Grid item container className={classes.toolbarGrid}>
                    <LogoAndBlogLink />
                </Grid>

                {streamingPage ? (
                    <Button className={classes.leaveStreaming} onClick={() => setOpenDisconnectModal(true)}>
                        {i18next.t('MenuStreamingPreComponentLeaveLiveEvent')}
                    </Button>
                ) : (
                    renderEventPageMenus()
                )}
            </Grid>
        </Toolbar>
    );

    return !(streamingPage && isMobileUI) ? (
        <AppBar variant="outlined" color="inherit" position="relative" className={clsx(classes.appBar)}>
            <DisconnectDialog
                open={openDisconnectModal}
                onLeaveNotFinishing={disconnectEvent}
                onLeaveFinishingEvent={closeEvent}
                onDismiss={() => setOpenDisconnectModal(false)}
            />

            {isMobileUI ? <HeaderMobile isCreator={isCreator} /> : renderDesktopToolbar()}

            {isCreator && <InfluencerSubmenu isMobileUI={isMobileUI} />}
            {purchased && <EventPurchasedSubmenu />}
        </AppBar>
    ) : null;
};

export default Header;
